
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Cooconwarming() {



  const cardData =
  {
    keyword: 'Cocoon Convective Patient Warming System',
    heading: 'Pharmacle Health Care Private Limited: Cocoon Convective Patient Warming System',
    headingDescription: 'Pharmacle Health Care Private Limited is a trusted provider of advanced thermal care solutions, including the Cocoon Convective Patient Warming System, designed to maintain optimal patient body temperature during surgical and critical care procedures. Our state-of-the-art warming systems utilize forced-air technology to deliver consistent and controlled heat, effectively preventing hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across India, our systems are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior patient warming systems that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Cocoon CWS 5000 – Advanced Convective Patient Warming System",
    "description": "The Cocoon CWS 5000 is a microprocessor-controlled patient warming system designed to maintain normothermia during surgical procedures. It features a two-speed fan motor, HEPA filtration, and multiple temperature settings, ensuring uniform heat distribution through Cocoon warming blankets. The system is lightweight, compact, and user-friendly, making it suitable for various clinical settings."
  },
  {
    "title": "Cocoon CWS 4000 – Efficient Thermal Management for Patient Care",
    "description": "The Cocoon CWS 4000 offers reliable convective warming with a microprocessor-controlled unit and a range of Cocoon warming blankets. It includes safety features like dual thermostats, a thermal safety switch, and a thermal fuse. The device is lightweight and compact, facilitating easy integration into operating rooms and intensive care units."
  },
  {
    "title": "Cocoon Warming Blankets – Versatile Solutions for Patient Warming",
    "description": "Cocoon warming blankets are designed to work seamlessly with Cocoon warming systems, providing consistent and uniform heat distribution. Available in various sizes and configurations, these blankets cater to different surgical procedures and patient needs, ensuring optimal thermal management and patient comfort."
  },
  {
    "title": "Medical Solutions Inc. – Manufacturer of Cocoon Patient Warming Systems",
    "description": "Medical Solutions Inc. is the manufacturer of the Cocoon Convective Patient Warming Systems, including models CWS 4000 and CWS 5000. The company focuses on developing innovative thermal management solutions that enhance patient safety and comfort during surgical procedures."
  },
  {
    "title": "Care Essentials – Innovators in Patient Warming Technology",
    "description": "Care Essentials specializes in patient warming solutions, offering the Cocoon range of convective warming systems and blankets. Established in 1996, the company emphasizes clinical and engineering excellence, providing products that deliver uniform heat distribution and improve patient outcomes."
  },
  {
    "title": "Respisure – Distributor of Cocoon Patient Warming Systems in India",
    "description": "Respisure is a distributor of Cocoon Convective Patient Warming Systems in India, offering models like the CWS 4000. The company provides FDA, CE, TGA, and Health Canada approved devices, ensuring high-quality thermal management solutions for healthcare providers."
  },
  {
    "title": "Hospital Store – Supplier of Cocoon CWS 5000 Patient Warmer",
    "description": "Hospital Store offers the Cocoon CWS 5000 patient warmer, featuring a two-speed fan motor, HEPA filtration, and multiple temperature settings. The device is designed to provide consistent and controlled warming, enhancing patient safety during surgical procedures."
  },
  {
    "title": "Tentabs – Retailer of Cocoon CWS 4000 Patient Warmer",
    "description": "Tentabs provides the Cocoon CWS 4000 patient warmer, a microprocessor-controlled device designed for effective thermal management. The system includes safety features like dual thermostats and a thermal safety switch, ensuring reliable performance in clinical environments."
  },
  {
    "title": "Biomed Suppliers – Provider of Cocoon Patient Warming Systems",
    "description": "Biomed Suppliers offers a range of Cocoon patient warming systems, including the CWS 5000 model. These systems are designed to maintain normothermia during surgical procedures, featuring user-friendly interfaces and advanced safety features."
  },
  {
    "title": "McKesson – Distributor of Cocoon Convective Patient Warming Units",
    "description": "McKesson distributes Cocoon convective patient warming units, such as the CWS 5000, which feature two-speed fan motors and HEPA filtration. These systems are designed to provide consistent and controlled warming, enhancing patient safety during surgical procedures."
  }
],

"services": [
    {
        "name": "Cocoon Convective Patient Warming System",
        "description": "Pharmacle Health Care offers the Cocoon Convective Patient Warming System, designed to maintain normothermia during surgeries and critical care procedures. This system utilizes advanced forced air convection technology to evenly distribute warm air, ensuring consistent and safe body temperature regulation. Trusted in operating rooms and recovery units, it enhances patient safety and supports faster recovery."
    },
    {
        "name": "Cocoon Patient Thermoregulation Devices",
        "description": "Our Cocoon Patient Thermoregulation Devices provide precise body temperature control for patients undergoing surgery or treatment. These devices use advanced convective warming technology to prevent hypothermia and maintain thermal stability. They are ideal for critical care, surgical suites, and recovery rooms, offering both comfort and medical-grade reliability."
    },
    {
        "name": "Cocoon Surgical Warming Systems",
        "description": "Pharmacle Health Care supplies Cocoon Surgical Warming Systems engineered to maintain optimal patient temperature throughout surgical procedures. These systems help reduce the risk of complications related to hypothermia by delivering consistent warming. Easy to integrate into surgical workflows, they are a reliable solution for temperature management in the operating room."
    },
    {
        "name": "Cocoon Forced Air Blanket Systems",
        "description": "We provide Cocoon Forced Air Blanket Systems designed to deliver gentle and effective convective heat to patients during surgery and recovery. These systems use high-quality blankets and forced air units to ensure uniform warmth, preventing temperature-related complications and enhancing patient outcomes across a wide range of medical scenarios."
    },
    {
        "name": "Cocoon Warming Blanket Suppliers",
        "description": "Pharmacle Health Care is a trusted supplier of Cocoon warming blankets, offering a range of sizes and configurations suitable for various medical applications. These blankets are designed for use with Cocoon forced air systems and provide efficient heat transfer, patient comfort, and infection control through high-quality, durable materials."
    },
    {
        "name": "Cocoon Medical Heating Equipment",
        "description": "We offer Cocoon medical heating equipment that includes advanced devices for thermal regulation during surgeries and critical care. These devices are essential for preventing perioperative hypothermia and are built for safety, efficiency, and ease of use. Cocoon equipment supports medical teams in delivering top-tier thermal care across clinical environments."
    },
    {
        "name": "Cocoon Operating Room Warming Machine",
        "description": "Our Cocoon Operating Room Warming Machines are engineered to maintain a stable thermal environment during surgical procedures. These machines integrate seamlessly with Cocoon warming blankets and other accessories, offering precise control and reliable performance. They are an essential component of any modern operating room setup."
    }
],
"tableData": [
    ["- Cocoon Convective Patient Warming System", "- Cocoon Patient Thermoregulation Devices"],
    ["- Cocoon Surgical Warming Systems", "- Cocoon Forced Air Blanket Systems"],
    ["- Cocoon Warming Blanket Suppliers", "- Cocoon Medical Heating Equipment"],
    ["- Cocoon Operating Room Warming Machine"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "The Cocoon Convective Patient Warming System offers advanced, reliable warming technology designed to provide consistent and controlled temperature regulation during medical procedures. Using convective air warming, it ensures that patients are kept warm and comfortable, preventing hypothermia during surgeries."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "Our Cocoon Convective Patient Warming System is part of a comprehensive solution designed to maintain optimal body temperature during surgeries and medical procedures. It helps prevent temperature-related complications, ensuring patients are safe and comfortable throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "The Cocoon Convective Patient Warming System is built with high-quality materials and manufactured to meet strict industry standards. Its durability and reliability ensure long-term use in demanding medical environments, providing healthcare providers with a dependable solution for patient care."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are at the core of the Cocoon Convective Patient Warming System. It provides gentle, controlled warmth to prevent hypothermia and temperature-related complications during medical procedures, helping patients stay comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "The Cocoon Convective Patient Warming System is highly versatile, making it suitable for a wide range of healthcare settings, including operating rooms, recovery units, and intensive care areas. It adapts to various patient care needs, ensuring effective temperature regulation in diverse medical environments."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Designed for seamless integration, the Cocoon Convective Patient Warming System can be easily incorporated into existing medical systems. It provides smooth operation with minimal disruption to ongoing medical procedures, ensuring healthcare professionals can maintain optimal patient care."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services to healthcare facilities, helping them select the right patient warming systems for their needs. Our team also provides ongoing support, including maintenance and troubleshooting, to ensure your Cocoon Convective Patient Warming System operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the forefront of our mission. Our Cocoon Convective Patient Warming System is designed to prevent temperature-related complications, ensuring patients receive the best possible care during critical medical procedures."
    }
]





















  }

  const faqData = [
    {
      question: "What is the Cocoon Convective Patient Warming System?",
      answer: "The Cocoon Convective Patient Warming System is a medical device designed to maintain or raise a patient’s body temperature during surgery or medical procedures. It works by using warm air to circulate through a special blanket or pad placed over the patient’s body, helping prevent hypothermia."
    },
    {
      question: "How does the Cocoon Convective Patient Warming System work?",
      answer: "The system uses a blower to blow warm, filtered air through a specially designed blanket that is placed over the patient. The blanket's perforated surface evenly distributes the warm air, providing a consistent and gentle warming effect to the patient."
    },
    {
      question: "Is the Cocoon Convective Patient Warming System suitable for all types of surgeries?",
      answer: "Yes, the Cocoon Convective Patient Warming System is versatile and can be used in a wide range of medical procedures, including surgeries where maintaining normothermia is crucial for patient safety and recovery."
    },
    {
      question: "How does the Cocoon Convective Patient Warming System prevent hypothermia?",
      answer: "The system prevents hypothermia by providing continuous, controlled warm airflow to the patient, keeping their body temperature within a safe and comfortable range during surgery or other medical procedures."
    },
    {
      question: "Is the Cocoon Convective Patient Warming System easy to use?",
      answer: "Yes, the Cocoon system is designed to be user-friendly, with simple controls for temperature adjustment. It is easy to operate for healthcare professionals and can be quickly set up to provide optimal warmth for patients."
    }
  ];
  
  const testimonialsData = [
    {
      text: "The Cocoon Convective Patient Warming System has been an essential part of our surgical procedures, ensuring patient safety by maintaining proper body temperature during long surgeries.",
      name: "Dr. Sunil Kapoor, Apollo Hospital"
    },
    {
      text: "We trust the Cocoon Warming System for patient comfort and temperature regulation. It's reliable and effective in preventing hypothermia during complex procedures.",
      name: "Dr. Priya Singh, Global Care Hospital"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  // const jsonData = {
  //   "@context": "https://schema.org",
  //   "@type": "Product",
  //   "name": "Cocoon Convective Patient Warming System",
  //   "description": "Discover the Cocoon Convective Patient Warming System – advanced medical heating equipment designed for surgical thermoregulation, forced air warming, and patient comfort in operating rooms and hospitals.",
  //   "brand": {
  //     "@type": "Brand",
  //     "name": "Cocoon"
  //   },
  //   "aggregateRating": {
  //     "@type": "AggregateRating",
  //     "bestRating": "5",
  //     "worstRating": "1",
  //     "ratingValue": "4.8",
  //     "ratingCount": "1355"
  //   }
  // };
  
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cocoon Convective Patient Warming System",
  "image": "https://www.yoursite.com/images/cocoon-patient-warming.jpg", // ✅ make sure the image is real, accessible, and fast-loading
  "description": "Discover the Cocoon Convective Patient Warming System – advanced medical heating equipment designed for surgical thermoregulation, forced air warming, and patient comfort in operating rooms and hospitals.",
  "brand": {
    "@type": "Brand",
    "name": "Cocoon"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "1355",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Dr. Amit Malhotra"
    },
    "reviewBody": "Cocoon warming system ensures quick and safe thermoregulation in high-risk surgeries. Our hospital trusts this device across all ORs."
  },
  "offers": {
    "@type": "Offer",
    "price": "Contact for quote",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.yoursite.com/cocoon-patient-warming-system"
  }
};

  

  

  return (
    <div>
  {/* <Helmet>
    <title>Cocoon Convective Patient Warming System | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore the Cocoon Convective Patient Warming System for surgical thermoregulation. Cocoon offers forced air blanket systems, warming machines, and patient heating devices. Call +91 8956322311."
    />
    <meta
      name="keywords"
      content="Cocoon Convective Patient Warming System, Cocoon Patient Thermoregulation Devices, Cocoon Surgical Warming Systems, Cocoon Forced Air Blanket Systems, Cocoon Warming Blanket Suppliers, Cocoon Medical Heating Equipment, Cocoon Operating Room Warming Machine"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet> */}


<Helmet>
  <title>Cocoon Convective Patient Warming System | Surgical Thermoregulation in India</title>
  <meta
    name="description"
    content="Buy Cocoon Convective Patient Warming System – India’s advanced medical thermoregulation device for surgical heating and patient comfort. Trusted in operating rooms and hospitals nationwide. Contact: +91 8956322311."
  />
  <meta
    name="keywords"
    content="Cocoon Convective Patient Warming System, Cocoon Surgical Thermoregulation India, Forced Air Patient Heating Device, Cocoon OR Warming Blanket Machine, Cocoon Medical Warming System India, Cocoon Hospital Thermal Equipment, Cocoon Blanket System India"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/55.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cooconwarming;